import { sessionDestination } from '../shared/session/session-destination';
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router';
import { LandingPage } from '../features/landing/landing-page';
import { getSessionGeneration } from '../shared/api/session-generation';
import { useSessionHint } from '../shared/session/use-session-hint';
import { useSession } from '../shared/session/use-session';
import { SessionSkeleton } from './session-skeleton';

export const LandingRoute = () => {
  const { user, isPending } = useSession();
  const sessionHint = useSessionHint();
  const { locale } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const signedOutGeneration = location.state?.signedOut;
  const keepsSignedOutLanding =
    typeof signedOutGeneration === 'number' && signedOutGeneration === getSessionGeneration();

  useEffect(() => {
    if (!keepsSignedOutLanding || user) return;
    void navigate(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      { replace: true },
    );
  }, [keepsSignedOutLanding, location.hash, location.pathname, location.search, navigate, user]);

  if (keepsSignedOutLanding) return <LandingPage />;
  if (user) return <Navigate to={sessionDestination(user, locale)} replace />;
  if (isPending && sessionHint) return <SessionSkeleton />;
  return <LandingPage />;
};
